import { useContext, useEffect, useState } from "react";
import { DashboardLayoutPropsType } from "../../../types/container.type";
import { MainArea } from "../../mainarea";
import { SideNavigation } from "../../navigation/sidenavigation";
import { TopNavigation } from "../../navigation/topnavigation";
import { AppLayoutWrapper } from "./styled";
import { useQuery } from "@tanstack/react-query";
import { retrieveUserProfileService } from "../../../utils/api/usermanagement/profile/retrieveUser";
import Cookies from "universal-cookie";
import { retrieveRoleByIdService } from "../../../utils/outbound/role/retrieveRoleById";
import { signOutUser } from "../../../utils/api/authentication/signout";
import { useNavigate } from "react-router-dom";
import { retrieveRoleService } from "../../../utils/api/usermanagement/role/retrieveRole";
import { retrieveInstitutionByIdService } from "../../../utils/outbound/institution/retrieveInstitutionById";
import uploadImageIcon from "../../../assets/icons/userprofileicon.svg";
import { Avatar } from "@mui/material";
import { AuthContext } from "../../../context/authContext";

export const AppLayout: React.FC<DashboardLayoutPropsType> = ({ pageId, pageTitle, children }) => {
    const cookies = new Cookies();
    const TOKEN = cookies.getAll().TOKEN;

    const navigate = useNavigate();
    const { setIsAuthenticated } = useContext(AuthContext);

    const [userRole, setUserRole] = useState("");
    const [institution, setInstitution] = useState({} as Record<string, any>);

    useEffect(() => {
        if (!pageId) return;
        document.body.id = pageId;
        return () => {
            document.body.removeAttribute("id");
        };
    }, [pageId]);

    const { data: loggedInUser } = useQuery({
        queryKey: ['loggedInUser', TOKEN],
        queryFn: async () => {
            return await retrieveUserProfileService(TOKEN);
        },
        enabled: !!TOKEN,
    });

    useEffect(() => {
        const fetchInstitution = async () => {
            if (!loggedInUser) return;
            try {
                const institution = await retrieveInstitutionByIdService(loggedInUser?._id, loggedInUser?.institution);
                return setInstitution(institution);
            } catch (error) {
                return console.error("Failed to fetch user institution:", error);
            }
        };
        fetchInstitution();
    }, [loggedInUser]);

    useEffect(() => {
        const fetchUserRole = async () => {
            if (!loggedInUser) return;
            const roleId = loggedInUser.roles[loggedInUser.roles.length - 1];
            try {
                const retrievedRole = await retrieveRoleByIdService(loggedInUser._id, roleId);
                setUserRole(retrievedRole?.title);
            } catch (error) {
                try {
                    const retrievedRole = await retrieveRoleService(TOKEN, roleId);
                    setUserRole(retrievedRole?.title);
                } catch (error) {
                    console.error("Role not found:", error);
                }
            }
        };
        fetchUserRole();
    }, [loggedInUser, TOKEN]);

    const handleLogOutUser = async () => {
        try {
            await signOutUser(TOKEN, false);
        } catch (error: any) {
            console.error('Logout failed, Contact Admin:', error);
        }
        cookies.remove("TOKEN", { path: "/" });
        setIsAuthenticated(false);
        return navigate("/", { replace: true });
    };

    return (
        <AppLayoutWrapper
            maxWidth={false}
        >
            <TopNavigation
                pageTitle={pageTitle}
                username={loggedInUser?.firstName}
                role={userRole}
                headshot={
                    <Avatar
                        variant="rounded"
                        src={loggedInUser?.avatar || uploadImageIcon}
                        alt={`${loggedInUser?.firstName} avatar`}
                        className="navigation-avatar"
                    />
                }
                handleLogOutUser={handleLogOutUser}
            />
            <SideNavigation
                username={loggedInUser?.firstName}
                role={userRole}
                logo={institution?.logo}
                headshot={
                    <Avatar
                        variant="rounded"
                        src={loggedInUser?.avatar || uploadImageIcon}
                        alt={`${loggedInUser?.firsName} avatar`}
                        className="navigation-avatar"
                    />
                }
                handleLogOutUser={handleLogOutUser}
            />
            <MainArea>
                {children}
            </MainArea>
        </AppLayoutWrapper >
    )
}